import React from 'react';
import { BackTestingChart as BackTestingChartContainer } from '@ihsm/ui-shared';
import { TimeserieChartVar99DataMock } from '../mocks';
import { BackTestingChartProps } from '../types';
import {
  getCustomOptions,
  varSeries,
  pnlSeries,
  varSeriesLabel,
} from '../utils';

export const BackTestingChart: React.FC<BackTestingChartProps> = ({
  height,
}): JSX.Element => {
  return (
    <BackTestingChartContainer
      varSeries={varSeries}
      pnlSeries={pnlSeries}
      height={height}
      varSeriesLimit={varSeriesLabel(TimeserieChartVar99DataMock[0].name)}
      customOptions={getCustomOptions()}
    />
  );
};
